import type { PlanFeature } from './types';

export const COMMON_FEATURES: PlanFeature[] = [
    { text: "Deal Opportunity Score", tooltip: "Clearitty Deal Opportunity Score is an AI-generated score that reflects how open a buyer is to potentially purchasing your product, based on their intent signals, tech stack fit, stakeholder activity, and 10K analysis when applicable" },
    { text: "AI Recommendation Engine", tooltip: "Automatically curates a high conversion company list based on buyer intent and external signals." },
    { text: "Discovery Engine", tooltip: "Discover new companies based on your search criteria and external signals." },
    { text: "Intent Data", tooltip: "Get real-time intent signals for companies based on their behavior and decision-making style." },
    { text: "Smart Company Filtering", tooltip: "Easily filter, sort, and prioritize recommended companies using attributes like size, revenue, fundraising, location, industry, real-time intent signals and tech stack." },
    { text: "Targeted Stakeholder Mapping View", tooltip: "Shows only your personalized key stakeholders across departments—like champions, sponsors, and decision-makers—to help you navigate the deal more effectively" },
    { text: "Persona Analysis", tooltip: "Shows only your personalized key stakeholders across departments—like champions, sponsors, and decision-makers—to help you navigate the deal more effectively" },
    { text: "Email Address & Phone Numbers", tooltip: "Get verified email and phone info, plus a personality breakdown of your buyer—including communication tips and trust-building dos and don'ts—based on role, behavior, and decision-making style." },
    { text: "AI-Powered Email Composer" },
    { text: "New Opportunities Notifications" },
    { text: "Fresh Signal Alerts", tooltip: "Get alerts when new companies meet your search criteria and external signals." },
    { text: "AI Deal Co-Pilot", tooltip: "Deal Co-Pilot helps you navigate the entire deal process, like a cheat sheet that turns complex data into clear, actionable steps." },
    { text: "Target Form 10-K Analysis" },
];

export const STARTER_FEATURES: PlanFeature[] = [
    ...COMMON_FEATURES,
    { text: "No Customized Signals", isNotIncluded: true },
    { text: "CSV Export (limited) - 10 companies / 20 Contacts", tooltip: "Limited CSV export capability" },
    { text: "No CRM Integration", isNotIncluded: true },
    { text: "No Shared Company Access", isNotIncluded: true },
    { text: "No Shared Credits Pool", isNotIncluded: true },
    { text: "No Team Management", isNotIncluded: true },
    { text: "No Community-Driven Real Deals' Data", isNotIncluded: true },
    { text: "No Buyer's Sales Cycle Analysis", isNotIncluded: true },
    { text: "No Deal Financial Statistics", isNotIncluded: true },
];

export const PRO_FEATURES: PlanFeature[] = [
    ...COMMON_FEATURES,
    { text: "Customized Signals" },
    { text: "CSV Export" },
    { text: "CRM Integration" },
    { text: "Shared Company Access", tooltip: "All team members can access the same unlocked companies" },
    { text: "Shared Credits Pool", tooltip: "Team members share a common credit pool for company purchases" },
    { text: "Team Management", tooltip: "Invite, manage, and control team member permissions" },
    { text: "No Community-Driven Real Deals' Data", isNotIncluded: true },
    { text: "No Buyer's Sales Cycle Analysis", isNotIncluded: true },
    { text: "No Deal Financial Statistics", isNotIncluded: true },
];

export const ADVANCED_FEATURES: PlanFeature[] = [
    ...COMMON_FEATURES,
    { text: "Customized Signals" },
    { text: "CSV Export" },
    { text: "CRM Integration" },
    { text: "Shared Company Access", tooltip: "All team members can access the same unlocked companies" },
    { text: "Shared Credits Pool", tooltip: "Team members share a common credit pool for company purchases" },
    { text: "Team Management", tooltip: "Invite, manage, and control team member permissions" },
    { text: "Community-Driven Real Deals' Data" },
    { text: "Buyer's Sales Cycle Analysis", tooltip: "See a breakdown of every step in the buyer's sales cycle—from initial outreach and legal handoff to procurement and go-live—based on verified deal data and AI analysis. Understand typical blockers, deal length, and what moves things forward." },
    { text: "Deal Financial Statistics", tooltip: "See deal financial statistics and insights based on verified deal data." },
];

export const PAYG_FEATURES: PlanFeature[] = [
    { text: "Deal Opportunity Score" },
    { text: "AI Recommendation Engine" },
    { text: "Discovery Engine" },
    { text: "Intent Data" },
    { text: "Smart Company Filtering" },
    { text: "Persona Analysis" },
    { text: "Email Address & Phone Numbers" },
    { text: "AI-Powered Email Composer" },
    { text: "AI Deal Co-Pilot" },
    { text: "MCP / API Access" },
    { text: "Taxes are calculated by Stripe at checkout" },
];
